import { Beneficiary, Society, StockPlan } from 'types';
import { tenderOfferParticipantStatus } from 'utils/tenderOfferTypes';

export const getSoldUnitsByBeneficiary = (
  tenderOffers: any[] | null | undefined,
  beneficiaryId: string | null | undefined
): number => {
  if (!tenderOffers || !beneficiaryId) return 0;

  const tenderOfferParticipants = tenderOffers
    ?.map((offer) => offer.participants)
    .flat();

  return (
    tenderOfferParticipants?.reduce((acc, participant) => {
      if (
        participant?.id === beneficiaryId &&
        participant.status === tenderOfferParticipantStatus.ACCEPTED &&
        participant.type === 'BENEFICIARY'
      ) {
        return acc + (participant.totalAccepted || 0);
      }
      return acc;
    }, 0) || 0
  );
};

export const getBeneficiaryGrantedUnits = (
  beneficiary: Beneficiary | null | undefined
): number => {
  if (!beneficiary) return 0;

  const units = beneficiary?.isCanceled
    ? beneficiary?.finalConsolidatedUnits
    : beneficiary?.sharesCount?.future;

  return units || 0;
};

export const getAssignedUnits = (
  beneficiary: Beneficiary | null | undefined,
  tenderOffers: any[] | null | undefined
): number => {
  if (!beneficiary) return 0;

  const grantedUnits = getBeneficiaryGrantedUnits(beneficiary);
  const soldUnits = getSoldUnitsByBeneficiary(
    tenderOffers,
    beneficiary?.['_id']
  );

  return Math.max(0, grantedUnits - soldUnits);
};

export const getGrantedUnitsFromPlan = (
  plan: StockPlan | null | undefined,
  society: Society | null | undefined,
  isDraft = false
): number => {
  if (!plan || !society) return 0;

  const beneficiaries =
    society?.beneficiaries?.filter((beneficiary) => {
      const isValid = isDraft ? beneficiary?.isDraft : !beneficiary?.isDraft;
      return isValid && beneficiary.plan === plan['_id'];
    }) || [];

  return beneficiaries.reduce(
    (acc, beneficiary) => acc + getBeneficiaryGrantedUnits(beneficiary),
    0
  );
};
